import { render, staticRenderFns } from "./NavSettingsItem.vue?vue&type=template&id=2d324cda&lang=pug"
import script from "./NavSettingsItem.vue?vue&type=script&lang=js"
export * from "./NavSettingsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports